import React from 'react';
import { useDispatch } from 'react-redux';
import { appointmentActions } from 'store';
import { CustomDelete, MinLoader, SimpleTooltip } from 'components';
import { Colors, FindLoad, hooksForTable, Images, PermissionList, RolePermission, useModal, User, useSecondaryModal } from 'utils';
import { UNAVAILABLE } from '../../../constants';

const CANCEL_ACTION_TYPE = 'CANCEL_APPT';
const DELETE_ACTION_TYPE = 'DELETE_ALL_APPT';
const GET_APPOINTMENT_DATES = 'GET_APPOINTMENT_DATES_BY_ID';
export const TemplateApptActions = ({ apptDate, handleClose, handleSave, loader, disabled, apptBetweenDates }) => {
    const dispatch = useDispatch();
    const { userInfo } = User();
    const { open, close } = useModal();
    const { closeSecondary } = useSecondaryModal();
    const loadDates = FindLoad(GET_APPOINTMENT_DATES);
    const checkCancel = apptDate?.locked
        ? RolePermission([PermissionList.LOCKED_APPT_EDIT?.code]) &&
          RolePermission([PermissionList.APPT_CANCEL?.code, PermissionList.APPT_SELF_CANCEL?.code])
        : RolePermission([PermissionList.APPT_SELF_CANCEL?.code, PermissionList.APPT_CANCEL?.code]);
    const checkDelete = apptDate?.locked
        ? RolePermission([PermissionList.LOCKED_APPT_EDIT?.code]) &&
          (RolePermission([PermissionList.APPT_SELF_DELETE?.code])
              ? userInfo?.id === apptDate?.staff?.id
              : RolePermission([PermissionList.UNRENDERED_APPT_DELETE?.code]))
        : RolePermission([PermissionList.UNRENDERED_APPT_DELETE?.code]);

    const closeAfterSuccess = () => {
        handleClose && handleClose();
        closeSecondary();
        close();
    };

    const handleCancel = () => {
        open(
            <CustomDelete
                info={'Cancel All Appts?'}
                text={'Are you sure you want to cancel all appts? This action cannot be undone.'}
                customConfirmBtn={'cancel-all-appt-box'}
                loaderColor={'#172B4D'}
                innerText={
                    <div>
                        <img src={Images.xCircle} alt="" />
                        <p>Confirm Cancellation</p>
                    </div>
                }
                body={
                    (apptBetweenDates?.startDate || apptBetweenDates?.endDate) && (
                        <div className="delete-modal-body-box">
                            <img src={Images.apptCalendar} alt="icon" />
                            <p>
                                {`Appointments from ${hooksForTable.handleCreatedAtDate(apptBetweenDates?.startDate)} to ${hooksForTable.handleCreatedAtDate(apptBetweenDates?.endDate)}`}
                            </p>
                        </div>
                    )
                }
                handleDel={() => dispatch(appointmentActions.cancelAppt(apptDate?.template, apptBetweenDates))}
                actionType={CANCEL_ACTION_TYPE}
                afterSuccess={closeAfterSuccess}
            />
        );
    };

    const handleDelete = () => {
        open(
            <CustomDelete
                info={'Delete All Appts?'}
                text={'Are you sure you want to delete all appts? This action cannot be undone.'}
                customConfirmBtn={'delete-all-appt-box'}
                loaderColor={'#B42318'}
                innerText={
                    <div>
                        <img src={Images.redTrash} alt="" />
                        <p>Confirm Deletion</p>
                    </div>
                }
                body={
                    (apptBetweenDates?.startDate || apptBetweenDates?.endDate) && (
                        <div className="delete-modal-body-box">
                            <img src={Images.apptCalendar} alt="icon" />
                            <p>
                                {`Appointments from ${hooksForTable.handleCreatedAtDate(apptBetweenDates?.startDate)} to ${hooksForTable.handleCreatedAtDate(apptBetweenDates?.endDate)}`}
                            </p>
                        </div>
                    )
                }
                handleDel={() => dispatch(appointmentActions.deleteAllAppt(apptDate?.template, apptBetweenDates))}
                actionType={DELETE_ACTION_TYPE}
                afterSuccess={closeAfterSuccess}
            />
        );
    };

    return (
        <div className="flex-align-center" style={{ gap: 24 }}>
            {checkCancel && apptDate?.type !== UNAVAILABLE && (
                <SimpleTooltip title={'This cancels all future appts after the selected date.'} arrow placement="top">
                    <button
                        style={{ opacity: loadDates?.length ? 0.5 : 1 }}
                        disabled={loadDates?.length}
                        className="cancel-template-appts"
                        onClick={handleCancel}
                    >
                        <img src={Images.xCircle} alt="cancel" />
                        <p> Cancel All </p>
                    </button>
                </SimpleTooltip>
            )}
            {checkDelete && (
                <SimpleTooltip title={'This deletes all future appts after the selected date.'} arrow placement="top">
                    <button
                        style={{ opacity: loadDates?.length ? 0.5 : 1 }}
                        disabled={loadDates?.length}
                        className="delete-template-appts"
                        onClick={handleDelete}
                    >
                        <img src={Images.redTrash} alt="delete" />
                        <p> Delete All </p>
                    </button>
                </SimpleTooltip>
            )}
            <button style={{ opacity: disabled ? 0.5 : 1 }} disabled={disabled} className="edit-template-appts" onClick={handleSave}>
                {loader ? (
                    <MinLoader margin={'0'} color={Colors.TextWhite} />
                ) : (
                    <>
                        <img src={Images.save} alt="save" />
                        <p>Save Edits</p>
                    </>
                )}
            </button>
        </div>
    );
};
